import React from "react";

import { Status } from "./styles";

interface Props {
  status: string;
  color: string;
  backgroundColor: string;
}

const StatusLead: React.FC<Props> = ({ status, color, backgroundColor }) => (
  <Status style={{ backgroundColor, color }}>{status}</Status>
);
export default StatusLead;
